module.exports = __webpack_public_path__ + "media/images/emblems/Saas-Fee-coat_of_arms-fa308671af014de61948fa29934328fb.svg";